var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item d-flex justify-content-between align-items-center"},[_vm._v("\n  "+_vm._s(_vm.numbers.number)+"\n  "),_c('span',{staticClass:"badge badge-primary badge-pill"},[_vm._v(_vm._s(_vm.numbers.total)+" times")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4317c033","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/number.vue
// module id = 393
// module chunks = 0